import { useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { changelogContent, CHANGELOG_VERSION } from "@/constants/changelog";

interface ChangelogModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ChangelogModal({ open, onOpenChange }: ChangelogModalProps) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      localStorage.setItem(`changelog-dismissed-v${CHANGELOG_VERSION}`, "true");
    }
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold flex items-center gap-2">
            <span className="text-2xl">✨</span>
            {changelogContent.title}
          </DialogTitle>
          <DialogDescription className="text-sm">Conocé las últimas actualizaciones y mejoras de DoctIA</DialogDescription>
        </DialogHeader>

        <div className="space-y-2 py-2">
          {changelogContent.items.map((item, index) => (
            <div key={index} className="flex gap-3 p-3 rounded-lg bg-secondary/50 hover:bg-secondary transition-colors">
              <div className="text-2xl flex-shrink-0">{item.icon}</div>
              <div className="flex-1">
                <h3 className="font-semibold text-base mb-0.5">{item.title}</h3>
                <p className="text-sm text-muted-foreground">
                  {item.description}
                  {item.link && (
                    <>
                      {" "}
                      <Link
                        to={item.link.url}
                        onClick={() => onOpenChange(false)}
                        className="text-primary hover:underline font-medium inline-flex items-center gap-1"
                      >
                        {item.link.text}
                      </Link>
                    </>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-2 border-t">
          <div className="flex items-center space-x-2">
            <Checkbox
              id="dont-show"
              checked={dontShowAgain}
              onCheckedChange={(checked) => setDontShowAgain(checked as boolean)}
            />
            <label
              htmlFor="dont-show"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
            >
              No mostrar nuevamente
            </label>
          </div>
          <Button onClick={handleClose}>Entendido</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
